import { get } from 'lodash';
import { create } from '@wix/fedops-logger';
import { isSSR } from './is-ssr';
import { getFedopsLoggerMock } from './fedops-logger-mock';

export const createFedopsLogger = fedopsAppName => {
  if (isSSR() || window.__IS_DEV_MODE__) {
    // can't use fedops on server side
    return getFedopsLoggerMock();
  } else {
    return create(fedopsAppName || get(window, '__CONFIG__.fedopsAppName'));
  }
};
